import fileUpload from './fileUpload';

const els = document.querySelectorAll('.form-item--upload-file');

for (const el of els) {
    fileUpload(el);
}
